import packageJson from '../package.json';

export const SDK_VERSION = packageJson.version;
